<div style="padding-top: 30px;"></div>
<div class="tab-pane" role="tabpanel" id="tiposol">
    <fieldset id="agregar_tiposol" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <div class="alert alert-danger" role="alert" id="tp_find_alert" name="tp_find_alert" hidden>
                        <i class="fa fa-exclamation-triangle fa-2x" aria-hidden="true"></i>
                        <span id="tp_dir_message"></span>
                    </div>

                    <div class="form-horizontal titulo">
                        <div class="form-group" align="left">
                            <div class="col-sm-2">
                                <label for="tipo_sol">Tipo de Solicitud:</label>
                            </div>
                            <div class="col-sm-3" class="inline" style="font-size: 13px">
                                <div class="col-md-4">
                                    <mat-checkbox (change)="add_tipo_solicitud_def_urb()"
                                        [(ngModel)]="solicitud_def_urb['DIVISION PREDIAL CON AFECTACION A UTILIDAD PUBLICA']"
                                        name="optradio" value="1">Divisi&oacute;n predial con afectaci&oacute;n<br> a
                                        utilidad publica (ART. 2.2.4. N°3 OGUC)</mat-checkbox>
                                    <label>(ART. 2.2.4. N°3 OGUC)</label>
                                </div>
                                <div class="col-md-3">
                                    <mat-checkbox (change)="add_tipo_solicitud_def_urb()"
                                        [(ngModel)]="solicitud_def_urb['COPROPIEDAD INMOBILIARIA CON AFECTACION A  UTILIDAD PUBLICA']"
                                        name="optradio" value="2">Copropiedad inmobiliaria con afectaci&oacute;n<br> a
                                        utilidad p&uacute;blica (ART. 2.2.4.N° 2)</mat-checkbox>
                                    <label>(ART. 2.2.4.N° 2)</label>
                                </div>
                            </div>
                            <div class="col-sm-2"></div>
                        </div>
                    </div>

                    <br>
                </div>

            </div>
        </div>
    </fieldset>
</div>
<div class="separator"></div>